import Vue from 'vue'
import { formatNumber } from '@/services/convert'
import { Tooltip } from 'ant-design-vue'

Vue.use(Tooltip)

export default Vue.extend({
  template: `
      <div class="custom-tooltip cell-ellipsis">
        <span style="display: block;" v-if="isCheck">
          <a-tooltip placement="right" :title="value ? parseFloat(value).toFixed(fixed).toString() : null">
            {{ value ? parseFloat(value).toFixed(fixed).toString() : null }}
          </a-tooltip>
        </span>
        <span style="display: block;" v-else>
          <a-tooltip placement="right" :title="value ? formatNumber(value) : null">
            {{ value ? formatNumber(value) : null }}
            </a-tooltip>
          </span>
      </div>`,
  data: function () {
    return {
      value: '',
      formatNumber: formatNumber,
      fixed: 0,
      isCheck: false,
    }
  },
  beforeMount() {
    this.value = this.params.value
    if (this.params.colDef['cellRendererParams']) {
      this.fixed = this.params.colDef['cellRendererParams'].fixed
      this.isCheck = this.params.colDef['cellRendererParams'].isCheck
    }
  },
})
